// extracted by mini-css-extract-plugin
module.exports = {"root":"fn8BsCoff6HHIsYej1aw","title":"lgvoGSlUG2yBwu0_jnyt","content":"KGt1Xr76bPR5IoNLoA2k","subtitle":"ik_qJK5M2XPJnqw_fxJ6"};